import styled from 'styled-components'
import salaoFestasImg from '../../assets/ART/salao-festas.webp'

export const Container = styled.div`
  background-image: url(${salaoFestasImg});
  background-color: transparent;
  background-repeat: no-repeat;
  background-size: cover;
  max-width: 100%;
  height: 70vh;
  position: relative;

  div {
    position: absolute;
    width: 32rem;
    bottom: -2rem;
    right: 2rem;

    @media (max-width: 575.98px) {
      width: 24rem;
      right: 0.25rem;
    }
  }
`

